import type { FC, PropsWithChildren, ReactElement, ReactNode } from 'react';
import { useDisclosure } from '@chakra-ui/react';
import { FormattedMessage } from 'react-intl';
import { Button, Drawer, Text } from '../../ui-components';
import { ContentAsset } from '../content-asset';

interface TermsConditionsPrivacyPolicyNewProps {
    prefix?: string;
}

export const TermsConditionsPrivacyPolicyNew: FC<
    PropsWithChildren<TermsConditionsPrivacyPolicyNewProps>
> = ({ prefix = '', children }) => {
    const { isOpen: isOpenTC, onOpen: onOpenTC, onClose: onCloseTC } = useDisclosure();
    const { isOpen: isOpenPP, onOpen: onOpenPP, onClose: onClosePP } = useDisclosure();

    const terms = (chunks: ReactNode[]): ReactElement => (
        <Button
            id={`${prefix ? `${prefix}-` : ''}terms-conditions-button`}
            onClick={onOpenTC}
            variant="text-button-no-hover"
        >
            <Text type="link" size="small">
                {chunks}
            </Text>
        </Button>
    );

    const policy = (chunks: ReactNode[]): ReactElement => (
        <Button
            id={`${prefix ? `${prefix}-` : ''}privacy-policy-button`}
            onClick={onOpenPP}
            variant="text-button-no-hover"
        >
            <Text type="link" size="small">
                {chunks}
            </Text>
        </Button>
    );

    return (
        <div
            data-testid={`${prefix ? `${prefix}-` : ''}terms-policy-text`}
            className="w-full text-center text-sm font-normal"
        >
            <Text size="small">
                {children}
                <FormattedMessage
                    id="disclaimer.terms_conditions.privacy_policy.component"
                    defaultMessage=" <terms>Terms and Conditions</terms> and <policy>Privacy Policy</policy>."
                    values={{
                        terms,
                        policy,
                    }}
                />
            </Text>

            <Drawer
                id={`${prefix ? `${prefix}-` : ''}terms-conditions-drawer`}
                isOpen={isOpenTC}
                onClose={onCloseTC}
            >
                <Text size="small">
                    <FormattedMessage
                        id="terms_conditions_privacy_policy_drawer.terms_conditions"
                        defaultMessage="Terms & Conditions"
                    />
                </Text>
                <ContentAsset className="text-xl" contentAssetId="terms_and_conditions" />
            </Drawer>

            <Drawer
                id={`${prefix ? `${prefix}-` : ''}privacy-policy-drawer`}
                isOpen={isOpenPP}
                onClose={onClosePP}
            >
                <Text size="small">
                    <FormattedMessage
                        id="terms_conditions_privacy_policy_drawer.privacy_policy"
                        defaultMessage="Privacy Policy"
                    />
                </Text>
                <ContentAsset className="text-xl" contentAssetId="privacy-policy" />
            </Drawer>
        </div>
    );
};

TermsConditionsPrivacyPolicyNew.defaultProps = {
    prefix: '',
};
